module.exports = __webpack_public_path__ + "static/media/img_core.27ec8bd4.webp";